var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicElements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 850,
    viewBox: "0 0 1440 850",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_847_5242",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 128,
    width: 1440,
    height: 723
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 128.873H0V850H1440V128.873Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_847_5242)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M1447.15 353.102L1208.96 592.643V1121.48L1447.15 881.942V353.102Z",
    fill: "url(#paint0_linear_847_5242)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_847_5242",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 128,
    width: 1440,
    height: 723
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 128.873H0V850H1440V128.873Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_847_5242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1132.24 652.694L1262.08 783.269V1071.54L1132.24 940.965V652.694Z",
    fill: "url(#paint1_linear_847_5242)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_847_5242",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 128,
    width: 1440,
    height: 723
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 128.873H0V850H1440V128.873Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_847_5242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1355.73 688.163L1357.13 685.157V379.325L1355.73 382.331V688.163Z",
    fill: "#70B5E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.21 695.742L1348.61 692.735V386.904L1347.21 389.91V695.742Z",
    fill: "#76BAE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1338.7 703.32L1340.1 700.314V394.482L1338.7 397.489V703.32Z",
    fill: "#7DBEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.19 710.899L1331.59 707.893V402.062L1330.19 405.068V710.899Z",
    fill: "#83C3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321.67 718.478L1323.08 715.472V409.64L1321.67 412.646V718.478Z",
    fill: "#89C8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.16 726.057L1314.56 723.05V417.219L1313.16 420.225V726.057Z",
    fill: "#90CDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.65 733.636L1306.05 730.63V424.798L1304.65 427.804V733.636Z",
    fill: "#96D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296.13 741.214L1297.54 738.208V432.376L1296.13 435.383V741.214Z",
    fill: "#9DD6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.62 748.794L1289.02 745.787V439.955L1287.62 442.961V748.794Z",
    fill: "#A3DBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.11 756.372L1280.51 753.366V447.534L1279.11 450.54V756.372Z",
    fill: "#A9E0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.6 763.951L1272 760.946V455.113L1270.6 458.119V763.951Z",
    fill: "#B0E4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1262.08 771.53L1263.48 768.523V462.691L1262.08 465.698V771.53Z",
    fill: "#B6E9FD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_847_5242",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 722
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 0H0V721.127H1440V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_847_5242)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M238.196 -177.168L0 62.3729V591.213L238.196 351.672V-177.168Z",
    fill: "url(#paint2_linear_847_5242)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_847_5242",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 722
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 0H0V721.127H1440V0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_847_5242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.557 -177.366L280.397 -46.7941V241.475L150.557 110.902V-177.366Z",
    fill: "url(#paint3_linear_847_5242)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_847_5242",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 850
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 0H0V849.998H1440V0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_847_5242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4568 201.661L24.0552 198.843V-87.8745L25.4568 -85.0561V201.661Z",
    fill: "#70B5E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9695 208.766L32.5679 205.948V-80.7695L33.9695 -77.9511V208.766Z",
    fill: "#76BAE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4822 215.872L41.0806 213.053V-73.6641L42.4822 -70.8457V215.872Z",
    fill: "#7DBEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9953 222.977L49.5938 220.158V-66.5591L50.9953 -63.7407V222.977Z",
    fill: "#83C3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.508 230.082L58.1064 227.264V-59.4536L59.508 -56.6352V230.082Z",
    fill: "#89C8EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0207 237.187L66.6191 234.369V-52.3486L68.0207 -49.5302V237.187Z",
    fill: "#90CDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5334 244.291L75.1318 241.473V-45.2441L76.5334 -42.4257V244.291Z",
    fill: "#96D1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0473 251.397L83.6445 248.579V-38.1387L85.0473 -35.3203V251.397Z",
    fill: "#9DD6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5593 258.502L92.1577 255.683V-31.0337L93.5593 -28.2153V258.502Z",
    fill: "#A3DBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.073 265.607L100.67 262.789V-23.9282L102.073 -21.1098V265.607Z",
    fill: "#A9E0F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.585 272.713L109.183 269.894V-16.8232L110.585 -14.0048V272.713Z",
    fill: "#B0E4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.099 279.817L117.697 276.999V-9.71826L119.099 -6.89986V279.817Z",
    fill: "#B6E9FD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_847_5242",
    x1: 1236.22,
    y1: 737.293,
    x2: 1500.51,
    y2: 737.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5494C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_847_5242",
    x1: 1247.22,
    y1: 862.116,
    x2: 1103.16,
    y2: 862.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5494C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_847_5242",
    x1: 27.2602,
    y1: 207.023,
    x2: 291.553,
    y2: 207.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5494C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_847_5242",
    x1: 265.537,
    y1: 32.0544,
    x2: 121.472,
    y2: 32.0544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5494C6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicElements);
export default __webpack_public_path__ + "static/media/graphic_elements.c31ba0eb80237705bef5bde34b46a3ba.svg";
export { ForwardRef as ReactComponent };